import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { LoggerModule } from 'ngx-logger';
import { routes } from './app.routes';
import { environment } from '@environment/environment';
import { errorInterceptor } from './shared/services/errors/error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([errorInterceptor])),
    importProvidersFrom(LoggerModule.forRoot({ level: environment.logLevel })),
  ],
};
